import { Component, OnInit, AfterViewInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ListItemRendererComponent } from 'gung-list';
import { EdiOrder, EdiMessageBase } from '../../../models/edi';
import { EdiOrderActionConfigService } from '../../../services/edi-order-action-config/edi-order-action-config.service';
import { EdiNavigationService } from '../../../services/edi/edi-navigation.service';

@Component({
    selector: 'lib-edi-order-card-list',
    templateUrl: './edi-order-card-list.component.html',
    styleUrls: ['./edi-order-card-list.component.css'],
    standalone: false
})
export class EdiOrderCardListComponent extends ListItemRendererComponent<EdiOrder[]> implements OnInit, AfterViewInit {
  selectedEdiOrders: EdiMessageBase[] = [];

  protected router = inject(Router);
  public ediNavigationService = inject(EdiNavigationService);

  ediNavigationBaseRoute: string;

  constructor(public actionConfigService: EdiOrderActionConfigService) {
    super();
  }

  getIds(orders: EdiOrder[]): string[] {
    return orders.map(o => o.id);
  }

  ngOnInit(): void {
    this.ediNavigationBaseRoute = this.router.url.split('?')[0];
  }

  ngAfterViewInit(): void {
    this.renderFinished?.emit();
  }

  selectEdiOrder(order: EdiMessageBase, select: boolean) {
    const idx = this.selectedEdiOrders.findIndex(o => o.id === order.id);
    if (select && idx === -1) {
      this.selectedEdiOrders.push(order);
    } else if (!select && idx > -1) {
      this.selectedEdiOrders.splice(idx, 1);
    }
  }

  trackByFn(index: any, item: any) {
    return item.documentReferences.buyerOrder.id + '' + item.erpIds;
  }
}
